<template lang="pug">
  div#conversa-wrapper-ext
</template>

<script>
import Wrapper from './Wrapper.vue'

export default {
  name: 'conversa-wrapper-ext-vue',
  extends: Wrapper,
  methods: {
    render_conversa() {
      if (this.conversa) {
        this.conversa.render('conversa-wrapper-ext')
      }
    },
  },
  mounted() {
    window.addEventListener('message', async (event) => {
      if (event.data === 'open conversa') {
        try {
          await this.buildConversa();
        } catch (error) {
          this.error = error;
        }
      }
    });

    window.parent.postMessage('conversa wrapper loaded', '*')
  }
}
</script>
